import {all, create} from 'mathjs';

const mathjs = create(all);
mathjs.config({number: 'BigNumber', precision: 18});
export default {
  install(Vue, options) {
    Vue.prototype.$add = function (a, b) {
      a=Number(a)*1
      b=Number(b)*1
      return mathjs.evaluate(a + '+' + b).toNumber();
    }

    Vue.prototype.$sub = function (a, b) {
     a=Number(a)*1
     b=Number(b)*1
      return mathjs.evaluate(a + '-' + b).toNumber();
    }

    Vue.prototype.$mul = function (a, b) {
     a=Number(a)*1
     b=Number(b)*1
      return mathjs.evaluate(a + '*' + b).toNumber();
    }

    Vue.prototype.$div = function (a, b) {
     a=Number(a)*1
     b=Number(b)*1
      return mathjs.evaluate(a + '/' + b).toNumber();
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./utils/textFormat.js
// module id = null
// module chunks = 